// src/components/VideoSection.jsx
import React from "react";
import styled from "styled-components";
import { colors } from "../styles/colors";
import IntroVideo from "../assets/video/intro.mp4";

const VideoWrapper = styled.section`
  padding: 60px 20px;
  text-align: center;
  background-color: ${colors.background};
`;

const Heading = styled.h2`
  font-family: 'Playfair Display', serif;
  font-size: 2.3rem;
  margin-bottom: 10px;
  color: ${colors.secondary};
`;



const VideoContainer = styled.div`
  max-width: 900px; /* Keeps the video player comfortably wide and premium on the page */
  width: 100%; 
  margin: 0 auto;
  border: 1px solid ${colors.primary};
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgba(15, 59, 46, 0.05);
  border-radius: 8px;
  
  video {
    width: 100%;
    height: auto;
    display: block;
    aspect-ratio: 16 / 9; 
    object-fit: contain; /* FIX: Shows the full video frame exactly like your second image */   
    background-color: #000; /* Replaced with black to look like a clean, standard media player backdrop if needed */
  }
`;

export default function VideoSection() {
  return (
    <VideoWrapper id="video">
      <Heading>Behind the Work</Heading>
      <VideoContainer>
        <video controls>
          <source src={IntroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </VideoContainer>
    </VideoWrapper>
  );
}